module.exports = __webpack_public_path__ + "assets/bankTransfer.4ca378a1ca0f94e5baf65df86f06072e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/bankTransfer.png
 ** module id = 143
 ** module chunks = 0
 **/